
export default {
  cities: state => state.cities
};
